/** Lookup route segment values (`GET /lookups/:type`). */
export enum LookupType {
  Branches = "branches",
  Groups = "groups",
  Ministries = "ministries",
  Activities = "activities",
  Members = "members",
  Users = "users",
  Departments = "departments",
  Accounts = "accounts",
  IncomeCategories = "incomeCategories",
  ExpenseCategories = "expenseCategories",
  // IBA-75: investigation launcher pickers.
  Funds = "funds",
  AccountingAccounts = "accountingAccounts",
}

/** Scope label on lookup item metadata (uppercase wire values). */
export enum LookupMetadataScope {
  Branch = "BRANCH",
  Parish = "PARISH",
  Shared = "SHARED",
}
